import React, { Component } from 'react';

import * as TEXTS from '../../../constants/texts';
import NavBar from '../SignIn/NavigationBar/NavigationBar.container';
import styles from './styles';
import BrowsersList from './browsers';

const WHY_NOT =
  'https://aula.help/product-overview/compatibility/about-internet-explorer';

const Browsers = (browser) => (
  <a target="_blank" href={browser.link} style={styles.browser}>
    <span>
      <img
        style={styles.browserImage}
        width="40"
        height="40"
        src={browser.image}
        alt={browser.name}
      />
    </span>
    <div style={styles.browserName}>{browser.name}</div>
  </a>
);

const IEMessage = (props) => (
  <div style={styles.background}>
    <NavBar hideActionButton />
    <div style={styles.container}>
      <div style={styles.title}>{TEXTS.IE_HEY_THERE}</div>
      <div style={styles.message}>
        {TEXTS.IE_REASON}
        <span>
          <a style={styles.whyNot} href={WHY_NOT} target="_blank">
            {TEXTS.IE_WHY_NOT}
          </a>
        </span>
      </div>
      <div style={styles.subHeader}>{TEXTS.IE_TO_USE_AULA}</div>
      <div style={styles.browserList}>
        {BrowsersList.map((b) => (
          <Browsers {...b} />
        ))}
      </div>
    </div>
  </div>
);

export default IEMessage;
